export enum MimeType {
  // Supported type for document upload
  pdf = 'application/pdf',
  zip = 'application/zip',
  binary = 'application/octet-stream',
}
